module.exports = __webpack_public_path__ + "img/chat.ead10fbb.png";